require.context('./import/Uus-Volta 10-2', false, /.png$/);
require.context('./import/Uus-Volta 10-3', false, /.png$/);
require.context('./import/Uus-Volta 8-1', false, /.png$/);
require.context('./import/Uus-Volta 8-2', false, /.png$/);
require.context('./import/Uus-Volta 8-3', false, /.png$/);
require.context('./import/Uus-Volta 9-1-2', false, /.png$/);
require.context('./import/Volta Villa', false, /.png$/);

import './sequence.scss';

import Pricelist from '../../modules/pricelist/pricelist';
import Component from '../component/component';

export default class Sequence extends Component {
    static initSelector: string = '.sequence';

    imageClass: string;
    imageContainerClass: string;
    nextClass: string;
    prevClass: string;
    prevSlideClass: string;
    loadedClass: string;
    activeClass: string;
    showClass: string;
    slides: JQuery;
    aptClass: string;
    sliderClass: string;
    timeouts: ReturnType<typeof setTimeout>[];
    timeout: ReturnType<typeof setTimeout>;

    constructor(target: HTMLElement) {
        super(target);

        this.sliderClass = 'sequence';
        this.imageClass = 'sequence__img';
        this.nextClass = 'sequence__button--next';
        this.prevClass = 'sequence__button--prev';
        this.loadedClass = 'is-sequence-loaded';
        this.activeClass = 'is-sequence-active';
        this.showClass = 'show-image';
        this.aptClass = 'sequence__apt';
        this.imageContainerClass = 'sequence__images';
        this.prevSlideClass = 'is-previous-slide';
        this.slides = $('.sequence__slide');

        this.init();
    }

    init(): void {
        this.countSlides();
        $('.' + this.nextClass).on('click', this.nextSlide.bind(this));
        $('.' + this.prevClass).on('click', this.prevSlide.bind(this));
        $('.' + this.aptClass).on('mouseover', this.hoverTrigger.bind(this));
        $('.' + this.aptClass).on('mouseout', this.removeHighlight.bind(this));

        this.element.find('.sequence__apt[data-name]').each((index: number, element: HTMLElement) => Pricelist.initTooltip(element));
    }

    countSlides(): void {
        for (let i: number = 0; i < this.slides.length; i++) {
            this.renderImages(this.slides.eq(i));
        }
    }

    renderImages(sqSlide: JQuery): void {
        const originImage: JQuery = sqSlide.find('.' + this.imageClass);
        const imageUrlBase: string = originImage.attr('src');
        const seqStart: number = sqSlide.data('seq-start');
        const seqSlideEnd: number = sqSlide.data('seq-end');
        const seqSlideMax: number = sqSlide.data('seq-max');
        const numberOfImages: number = seqSlideMax ? (seqSlideMax - seqStart + seqSlideEnd) : (seqSlideEnd - seqStart);
        let seqEnd: number = seqStart + numberOfImages;

        for (let _i: number = seqStart + 1; _i <= seqEnd; _i++) {
            if (seqSlideMax && _i > seqSlideMax) {
                _i = 0;
                seqEnd = seqSlideEnd;
            }

            const formattedNumber: string = ('0000' + _i).slice(-4);
            const last: string = imageUrlBase.split('_').pop();
            const newUrl: string = imageUrlBase.replace(last, formattedNumber + '.png');
            const theImage: JQuery = originImage.clone().removeClass(this.imageClass + '--first ' + this.showClass);
            const newSrc: string = theImage.attr('src').replace(imageUrlBase, newUrl);

            theImage.attr('src', newSrc);
            sqSlide.find('.' + this.imageContainerClass).append(theImage);
        }

        sqSlide.addClass(this.loadedClass);
    }

    removeHighlight(): void {
        Pricelist.removeHighlights();
    }

    hoverTrigger(event: JQuery.TriggeredEvent): void {
        const target: JQuery = $(event.currentTarget);
        const aptId: string = target.data('name');

        target.addClass('is-highlighted');

        Pricelist.highlightApartment(aptId);
    }

    nextSlide(): void {
        const btn: JQuery = $('.' + this.nextClass);
        const isReverse: boolean = btn.data('reverse') ? btn.data('reverse') : false;

        if (isReverse) {
            this.startSequence(this.getPrevSlide($('.' + this.activeClass)), true);
        } else {
            this.startSequence($('.' + this.activeClass), false);
        }
    }

    prevSlide(): void {
        const btn: JQuery = $('.' + this.prevClass);
        const isReverse: boolean = ! (btn.data('reverse') ? btn.data('reverse') : false);

        if (isReverse) {
            this.startSequence(this.getPrevSlide($('.' + this.activeClass)), true);
        } else {
            this.startSequence($('.' + this.activeClass), false);
        }
    }

    startSequence(toSlide: JQuery, reverse: boolean = false, delay: number = 23, onComplete: () => void | null = null): void {
        this.clearTimeouts();
        let current: JQuery = $('.' + this.activeClass);

        $('.' + this.sliderClass).addClass('is-disabled');
        const currentImage: number = current.find('.' + this.showClass).index();

        if (reverse) {
            if (currentImage === 0) {
                current.find('.' + this.imageClass).removeClass(this.showClass);
                current.removeClass(this.activeClass);
                current = this.getPrevSlide(current);
                current.addClass(this.activeClass);
                current.find('.' + this.imageClass).last().addClass(this.showClass);
                this.startSequence(current, reverse, delay, onComplete);
            } else {
                let tick: number = 0;

                for (let _i: number = currentImage; _i >= 0; _i--) {
                    this.timeouts.push(setTimeout(() => {
                        current.find('.' + this.imageClass).removeClass(this.showClass);
                        current.find('.' + this.imageClass).eq(_i).addClass(this.showClass);
                        if (_i === 0) {
                            if (current.index() !== toSlide.index()) {
                                this.startSequence(toSlide, reverse, delay, onComplete);
                            } else {
                                $('.' + this.sliderClass).removeClass('is-disabled');
                                this.checkLabel();
                                this.element.trigger('sequence.complete');
                                if (onComplete) {
                                    onComplete();
                                }
                            }
                        }

                    }, tick * delay));
                    tick++;
                }
            }
        } else {
            const to: number = current.find('.' + this.imageClass).length - 1;

            if (to === currentImage) {
                current.find('.' + this.imageClass).removeClass(this.showClass);
                current.removeClass(this.activeClass);
                current = this.getNextSlide(current);
                current.addClass(this.activeClass);
                current.find('.' + this.imageClass).first().addClass(this.showClass);
                this.startSequence(current, reverse, delay, onComplete);
            } else {
                for (let _i: number = currentImage; _i <= to; _i++) {
                    this.timeouts.push(setTimeout(() => {
                        current.find('.' + this.imageClass).removeClass(this.showClass);
                        current.find('.' + this.imageClass).eq(_i).addClass(this.showClass);
                        if (_i >= to) {
                            if (current.index() !== toSlide.index()) {
                                this.startSequence(toSlide, reverse, delay, onComplete);
                            } else {
                                current.removeClass(this.activeClass);
                                current.find('.' + this.imageClass).removeClass(this.showClass);
                                current = this.getNextSlide(current);
                                current.addClass(this.activeClass);
                                current.find('.' + this.imageClass).first().addClass(this.showClass);
                                $('.' + this.sliderClass).removeClass('is-disabled');
                                this.checkLabel();
                                this.element.trigger('sequence.complete');
                                if (onComplete) {
                                    onComplete();
                                }
                            }
                        }
                    }, _i * delay));
                }
            }
        }
    }

    checkLabel(): void {
        const current: JQuery = $('.' + this.activeClass);

        $('.js-sequence-front, .js-sequence-back').removeClass('is-visible');
        if (current.index() === 0 || current.index() === 3) {
            $('.js-sequence-back').addClass('is-visible');
        } else {
            $('.js-sequence-front').addClass('is-visible');
        }
    }

    private clearTimeouts(): void {
        if (this.timeouts) {
            this.timeouts.forEach((value: ReturnType<typeof setTimeout>, index: number) => {
                clearTimeout(this.timeouts[index]);
            });
        }
        this.timeouts = [];
    }

    private getPrevSlide(current: JQuery): JQuery {
        let prev: JQuery;

        if (current.index() === this.slides.first().index()) {
            prev = this.slides.last();
        } else {
            prev = current.prev();
        }

        return prev;
    }

    private getNextSlide(current: JQuery): JQuery {
        let next: JQuery;

        if (current.index() === this.slides.last().index()) {
            next = this.slides.first();
        } else {
            next = current.next();
        }

        return next;
    }
}

